module.exports = __webpack_public_path__ + "static/assets/9b2413f6799359b2c2b83122bfd74e6c.png";